import {
  arrayBuilderItemSubsequentPageTitleUI,
  radioUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { PROVIDER_TYPE_LABELS } from '../../../constants';
import { providerFacilityItemSchema } from '../../../schema';
import { getProviderFacilityItem } from './options';

const { providerType, providerTypeOther } =
  providerFacilityItemSchema.properties;

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => formData?.providerFacilityName,
      undefined,
      false,
    ),
    providerType: radioUI({
      title: 'What kind of provider is this?',
      hint: 'Selecting "I\u2019m not sure" won\u2019t negatively affect your claim.',
      labels: PROVIDER_TYPE_LABELS,
    }),
    providerTypeOther: textUI({
      title:
        'If you selected \u2018Other,\u2019 what kind of facility did you visit?',
      hideIf: (formData, index, fullData) =>
        getProviderFacilityItem(formData, index, fullData).providerType !==
        'other',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      providerType,
      providerTypeOther,
    },
  },
};
